<div class="card custom-card my-3 border-0">
  <div class="card-body mb-3">
    <div class="row mb-3">
      <label class="col-form-label col-auto">
        <i class="bi bi-search me-2"></i>
        ค้นหาข้อมูล
      </label>
    </div>
    <hr>
    <div class="row mb-1 ps-4 pe-4">
      <div class="col-xl-6 col-sm-12 mt-3">
        <div>
          <label>
            ประเภทวัตถุดิบ
          </label>
        </div>
        <div>
          <app-qrtracetype-autocomplete id="type" name="type" [(ngModel)]="searchParam.type" (ngModelChange)="onchangeType()"></app-qrtracetype-autocomplete>
        </div>
      </div>
      <div class="col-xl-6 col-sm-12 mt-3">
        <div>
          <label>
            ชนิดวัตถุดิบ
          </label>
        </div>
        <div>
          <app-product-group-detail-autocomplete id="category" name="category" [disabled]="!searchParam.type" [qrTracesId]="searchParam.type?.id" [(ngModel)]="searchParam.category"></app-product-group-detail-autocomplete>
        </div>
      </div>
    </div>
    <div class="row mb-1 ps-4 pe-4">
      <div class="col-xl-6 col-sm-12 mt-3">
        <div>
          <label>
            ชื่อเกษตรกร
          </label>
        </div>
        <div>
          <input type="text" class="form-control" id="manufacturerName" name="manufacturerName" [(ngModel)]="searchParam.manufacturerName">
        </div>
      </div>
      <div class="col-xl-6 col-sm-12 mt-3">
        <div>
          <label>
            ชื่อวัตถุดิบ
          </label>
        </div>
        <div>
          <input type="text" class="form-control" id="nameRaw" name="nameRaw" [(ngModel)]="searchParam.name">
        </div>
      </div>
    </div>
    <div class="row mb-3 mt-5">
      <div class="col-12 text-start">
        <div class="text-center">
          <button type="button" (click)="search()"
                  class="btn btn-custom btn-custom-theme me-2">
            <i class="bi bi-search me-2"></i>
            ค้นหา
          </button>
          <button type="button" (click)="clear()"
                  class="btn btn-custom btn-light me-2">
            <i class="bi bi-arrow-clockwise me-2"></i>
            ล้างข้อมูล
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card custom-card my-3 border-0">
  <div class="card-body mb-3">
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <caption>
          รายการทั้งหมด {{ pageData?.totalElements | number }} รายการ
        </caption>
        <thead class="color-black font-weight-light">
        <tr class="table-light text-center" style="background-color: #eeeeee;">
          <th nowrap scope="col" class="">ลำดับ</th>
          <th nowrap scope="col" class="">ประเภทวัตถุดิบ</th>
          <th nowrap scope="col" class="">ชนิดวัตถุดิบ</th>
          <th nowrap scope="col" class="">ชื่อวัตถุดิบ</th>
          <th nowrap scope="col" class="">ชื่อเกษตรกร</th>
          <th nowrap scope="col" class="">ติดต่อ</th>
        </tr>
        </thead>
        <tbody class="table-borderless">
        <tr *ngIf="!pageData?.content?.length">
          <td class="text-muted text-center" colspan="7">
            <app-not-found></app-not-found>
          </td>
        </tr>
        <tr *ngFor="let item of pageData?.content; let i= index">
          <td class="text-center">{{ (pageData.number * pageData.size) + (i + 1) }}</td>
          <td class="text-center">{{item.qrTraceProductType?.name}}</td>
          <td class="text-center">{{item.productGroupDetail?.name}}</td>
          <td class="text-center">{{item.name ?? '-'}}</td>
          <td class="text-center">{{item.manufacturer?.contractUser?.fullName}}</td>
          <td class="text-center">{{item.manufacturer?.contractUser?.telephoneNo}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <ngb-pagination class="d-flex justify-content-center"
                    [maxSize]="5"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    [page]="pageData?.number + 1"
                    (pageChange)="search($event)"
                    [pageSize]="pageData?.size"
                    [collectionSize]="pageData?.totalElements"></ngb-pagination>
  </div>
</div>
